import FingerprintJS from '@fingerprintjs/fingerprintjs';


export const fpPromise =  FingerprintJS.load();   